module.exports = __webpack_public_path__ + "img/9A7467_D2C2BF_662D22_CCB2A5-256px.2ab58809.png";